import { render } from "./HomeGIC.vue?vue&type=template&id=6d391470"
import script from "./HomeGIC.vue?vue&type=script&lang=js"
export * from "./HomeGIC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__